import { ActiveRecord, sources } from '@mysidewalk/active-record';
/**
 */
class Invitation extends ActiveRecord {
    initialize(props) {
        super.initialize(props);
        this.expiredAt = this.expiredAt ? new Date(this.expiredAt) : undefined;
        this.redeemedAt = this.redeemedAt ? new Date(this.redeemedAt) : undefined;
    }
    get status() {
        const result = this.isRedeemed ? 'ACCEPTED' : 'PENDING';
        return this.isExpired ? 'EXPIRED' : result;
    }
    get isRedeemed() {
        return !!this.redeemedAt;
    }
    /**
     * Considers an invitation expired if the invitation has an expiration date
     * and the current date is after the specified expiration date.
     * @returns {Boolean}
     */
    get isExpired() {
        const hasDate = this.expiredAt !== undefined && this.expiredAt !== null;
        return hasDate && (Date.now() >= this.expiredAt.valueOf());
    }
}
Invitation.$AR = {
    url: '',
    SourceClass: sources.ActiveRecordJSONAPISource,
    options: {
        responseRecordsPropertyName: 'invitations',
    },
};
export default Invitation;
